import { Dropdown, MenuProps, Typography } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import ThreeDotsHrz from "./../../../graphics/svgs/threeDotsHrz.svg";

const UserDropDown: React.FC<IUserDropDown> = ({ userId, fullName }) => {
  const navigate = useNavigate();
  const orderOptions: MenuProps["items"] = [
    {
      key: "VIEW_DETAILS",
      label: (
        <Typography className="general-label-class">View Details</Typography>
      ),
    },
  ];

  const handleMenuClick = (e: any) => {
    switch (e.key) {
      case "VIEW_DETAILS":
        navigate(`/user-profile/${userId}/${fullName}`);
        break;
    }
  };
  return (
    <>
      <Dropdown
        menu={{
          items: orderOptions,
          onClick: handleMenuClick,
        }}
        placement="bottomRight"
      >
        <img src={ThreeDotsHrz} style={{ width: "25px", cursor: "pointer" }} />
      </Dropdown>
    </>
  );
};

export default UserDropDown;
